import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const MobileNavButton = styled.a`
  cursor: pointer;
  display: flex;
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  color: ${ds.brand('regular')};
  font-weight: ${({ active }) => (active ? ds.get('type.fontWeight.bold') : ds.get('type.fontWeight.regular'))};
  
  padding: ${ds.get('metrics.xs')} 0 ${ds.get('metrics.xs')} 0;
  
  ${media.desktop`
      padding: 0 ${ds.get('metrics.s')};
  `}
`;

export default MobileNavButton;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MobileNavigation/MobileNavButton.jsx